export enum DialogSize {
	EXTRA_LARGE = 'xl',
	LARGE = 'lg',
	MEDIUM = 'md',
	SMALL = 'sm',
	UNSET = 'unset',
}
